// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"db6c998f","498":"e98a9ad2","703":"f3444e30","787":"a6b2c861"}[chunkId] + ".chunk.js";
};